import FormRadioGroupIcons from "../../shared/Inputs/FormRadioGroupIcons";
import { NumberInput } from "../../shared/Inputs/NumberInput";

interface IGeneralPriceSettingsProps {
  label: string | undefined;
  objectName: string;
  register: any;
  setValue: any;
  watch: any;
  minVal?: number | null;
  disabled?: boolean;
  width?: string;
  containerClasses?: string;
  customInputClasses?: string;
  customRadioClasses?: string;
  customRadioContainerClasses?: string;
}

interface IOptions {
  value: Boolean;
  name: string;
}

export default function GeneralPriceSettingSingle({ label, objectName, register, setValue, watch, minVal, disabled, width, containerClasses, customInputClasses, customRadioClasses, customRadioContainerClasses }: IGeneralPriceSettingsProps) {

  const options: IOptions[] = [
    { value: true, name: "£" },
    { value: false, name: "%" }
  ]

  const valueRegisterName = objectName ? `${objectName}.value` : "value";
  const isFixedRegisterName = objectName ? `${objectName}.isFixed` : "isFixed";

  return (
    <div className={`flex items-center gap-x-4 ${disabled ? "opacity-50 pointer-events-none" : ""} ${containerClasses}`}>
      <NumberInput label={label} registerName={valueRegisterName} register={register} classes={width ? `${width}` : `w-32 lg:w-64`} minVal={minVal} inputClasses={customInputClasses} />
      <FormRadioGroupIcons label="" register={register} registerName={isFixedRegisterName} options={options} setValue={setValue} watch={watch} containerClassName={`mt-3 ${customRadioContainerClasses}`} customClasses={customRadioClasses} />

      {/* <SelectInput label="" register={register} registerName={isFixedRegisterName} options={options} setValue={setValue} watch={watch} cols="pt-5 w-64" /> */}
    </div>
  )
}